import { get, post, put, del } from '../../../../../api/axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL;

export function getOfferAssets(documentId, siteId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/assets`);
}

export function getOfferAssetsHeader(documentId, siteId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/assetsHeader`);
}

export function deleteOfferAsset(documentDetailId, documentId, siteId) {
  return del(url + `/leasingoffers/${documentId}/${siteId}/offerasset/${documentDetailId}`, {
    documentId: documentId,
    siteId: siteId,
    documentDetailId: documentDetailId
  });
}

export function getOfferAsset(documentId, siteId, assetId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/asset/${assetId}`);
}

export function getAssetTypeProperties(assetTypeId) {
  return get(`${url}/leasingoffers/asset/assetType/${assetTypeId}/properties`);
}

export function getAssetPropertyDetails(propId) {
  return get(`${url}/leasingoffers/asset/property/${propId}/detail`);
}

export function getPropertyByCode(propertyCode) {
  return get(`${url}/leasingoffers/asset/property/${propertyCode}/detailCode`);
}

export function getPropertiesHistory(assetId) {
  return get(`${url}/leasingoffers/asset/propertyHistory/${assetId}`);
}

export function getContactInfo(search, partnerId = '', role) {
  return get(`${url}/leasingoffers/asset/partner/contactinfo?search=${search}&partnerId=${partnerId}&role=${role}`);
}

export function getRegistrationCodes(search) {
  return get(`${url}/leasingoffers/asset/partner/registrationcode?search=${search}`);
}

export function retrieveAssetData(chassisNumber, commandNumber) {
  return post(`${url}/asset/assetData`, { chassisNumber, commandNumber });
}

export function createOfferAsset(offerAsset) {
  return post(url + `/leasingoffers/${offerAsset.documentId}/${offerAsset.siteId}/assets/new`, offerAsset);
}

export function splitAsset(documentId, siteId, documentDetailId, quantity) {
  return post(url + `/leasingoffers/${documentId}/${siteId}/assets/split-asset`, {
    documentId,
    siteId,
    documentDetailId,
    quantity
  });
}

export function saveAssetInformation(documentId, siteId, documentDetailId, assetInformation) {
  return post(url + `/leasingoffers/${documentId}/${siteId}/assets/asset-information`, {
    documentId,
    siteId,
    documentDetailId,
    assetInformation
  });
}

export function deleteAssetInformation(documentId, siteId, documentDetailId, assetInformation) {
  return del(url + `/leasingoffers/${documentId}/${siteId}/assets/asset-information`, {
    documentId,
    siteId,
    documentDetailId,
    assetInformation
  });
}

export function updateOfferAsset(offerAsset) {
  return put(`${url}/leasingoffers/${offerAsset.documentId}/${offerAsset.siteId}/assets/${offerAsset.documentDetailId}`, offerAsset);
}

export function updateOfferAssetChassisNumber(documentId, siteId, documentDetailId, chassisNumber) {
  return put(url + '/leasingoffers/asset/chassis-number', {
    documentDetailId: documentDetailId,
    chassisNumber: chassisNumber,
    documentId: documentId,
    siteId: siteId
  });
}

export function getSupplierInfo(dealerId) {
  return get(`${url}/leasingoffers/asset/get-supplier-info?dealerId=${dealerId}`);
}

export function retrievePartnerFromQuery(documentId, siteId, partnerInformation) {
  return put(`${url}/leasingoffers/asset/retrieve-partner-from-query`, { documentId, siteId, partnerInformation });
}

export function externalSearchForPartner(data) {
  return put(`${url}/leasingoffers/asset/partner-from-query/registration-code`, data);
}

export function externalSearchForPartnerAlpha(data) {
  return put(`${url}/leasingoffers/asset/partner-from-query/alpha/registration-code`, data);
}

export function getSecondHandProperties(itemId) {
  return get(`${url}/leasingoffers/asset/secondHandProperties/${itemId}`);
}

export function getAssetMandatoryProperties(assetId, assetTypeId, assetCategory, assetClassification) {
  const details = `${assetId ?? ''}_${assetTypeId ?? ''}_${assetCategory ?? ''}_${assetClassification ?? ''}`;
  return get(`${url}/leasingoffers/asset/${details}/mandatory-properties`);
}
